// extracted by mini-css-extract-plugin
module.exports = {"body":"modal-body_body__C4Lhp"};